/**
 * Test ID utilities for Popover component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Popover trigger
 * @param identifier - Popover identifier
 * @returns Test ID string
 */
export const setPopoverTriggerTestId = (identifier: string): string =>
  generateTestId("PopoverTrigger", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Popover content
 * @param identifier - Popover identifier
 * @returns Test ID string
 */
export const setPopoverContentTestId = (identifier: string): string =>
  generateTestId("PopoverContent", identifier.replace(/\s+/g, "-").toLowerCase());
